import script from "./Error404View.vue?vue&type=script&setup=true&lang=js"
export * from "./Error404View.vue?vue&type=script&setup=true&lang=js"

import "./Error404View.vue?vue&type=style&index=0&id=4fe94654&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe94654"]])

export default __exports__